import React, { useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Alert,
  Box,
  Container,
  FormLabel,
  FormGroup,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  CardHeader,
  Card,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import UserHeader from "../../components/Headers/UserHeader.js";
import ProfileEdit from "./Profile_edit.js";
import EmailIcon from "@material-ui/icons/Email";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import SchoolIcon from "@material-ui/icons/School";
import GroupIcon from "@material-ui/icons/Group";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Profile = () => {
  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [searchitems, setSearchItems] = React.useState(0);

  const [state, setState] = React.useState({
    email: "",
    username: "",
    password: "",
    password2: "",
    groups: [],
    errorMessage: "",
    right: false,
    radioList: "A",
    delete_id: "",
    active: "1",
    showPassword: false,
    showPassword2: false,
  });
  console.log(state);
  const [countlist, setlists] = useState([]);
  const [userlist, setusers] = useState([]);
  const [grouplist, setgroup] = useState([]);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleClickShowPassword2 = () => {
    setState({
      ...state,
      showPassword2: !state.showPassword2,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (state.password !== state.password2) {
      setState({ errorMessage: "The passwords doesn't match" });
    } else {
      const register = {
        email: state.email,
        username: state.username,
        password: state.password,
        groups: [state.groups],
        is_active: state.active,
      };
      fetch(`${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(register),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.email && data.username) {
            window.location.reload();
          } else {
            if (data.username) {
              setState({ email: "" });
              setState({ username: "" });
              setState({ password: "" });
              setState({ password2: "" });
              setState({ groups: [] });
              setState({ errorMessage: data.username[0] });
            } else if (data.email) {
              if (
                data.email[0] === "User already exist, It is in Inactive state"
              ) {
                toggle3();
              } else if (
                data.email[0] ===
                "User already exist, but user not in our organization"
              ) {
                toggle4();
              } else {
                setState({ email: "" });
                setState({ username: "" });
                setState({ password: "" });
                setState({ password2: "" });
                setState({ groups: [] });
                setState({ errorMessage: data.email[0] });
              }
            } else if (data.password) {
              setState({ email: "" });
              setState({ username: "" });
              setState({ password: "" });
              setState({ password2: "" });
              setState({ groups: [] });
              setState({ errorMessage: data.password[0] });
            } else {
              setState({ email: "" });
              setState({ username: "" });
              setState({ password: "" });
              setState({ password2: "" });
              setState({ groups: [] });
              setState({ errorMessage: data.errors.email[0] });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          setState({ errorMessage: "Something Went Wrong" });
        });
    }
  };
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlists(resp));
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          localStorage.setItem("user_access", data.detail);
        } else {
          setusers(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/user_management/group/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          localStorage.setItem("user_access", data.detail);
        } else {
          setgroup(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);
  const Delete = (userId) => {
    return function () {
      fetch(
        `${process.env.REACT_APP_API_URL}/api/user_management/user/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify({
            username: "",
            password: "",
            groups: [],
            active: "0",
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          window.location.reload();
        });
    };
  };

  const activate = (userId) => {
    return function () {
      const activate = {
        username: state.username,
        password: state.password,
        groups: state.groups.toString(),
        active: state.active,
      };
      fetch(
        `${process.env.REACT_APP_API_URL}/api/user_management/user/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(activate),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          window.location.reload();
        });
    };
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const [open2, setOpen2] = useState(false);
  const [focusAfterClose2] = useState(true);
  const toggle2 = () => setOpen2(!open2);

  const [open3, setOpen3] = useState(false);
  const [focusAfterClose3] = useState(true);
  const toggle3 = () => setOpen3(!open3);

  const [open4, setOpen4] = useState(false);
  const [focusAfterClose4] = useState(true);
  const toggle4 = () => setOpen4(!open4);

  function del(deleteid) {
    setState({ delete_id: deleteid });
  }

  function refreshPage() {
    window.location.reload();
  }

  const unique = [
    ...new Set(
      userlist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];
  console.log(unique);
  const cloumnName = "name";

  return (
    <>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open4}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose4}
        aria-describedby="alert-dialog-slide-description"
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "810",
            color: "rgb(48, 68, 115)",
            fontFamily: "sans-serif",
            lineHeight: "4.5rem",
          }}
        >
          User is Inactive
        </h2>
        <DialogContent>
          Please Contact{" "}
          <a
            href="mailto:support@zippyops.com"
            style={{ marginLeft: "5px", color: "#2096ff" }}
          >
            support@zippyops.com
          </a>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={toggle4} size="sm">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "810",
            color: "rgb(48, 68, 115)",
            fontFamily: "sans-serif",
            lineHeight: "4.5rem",
          }}
        >
          Delete User
        </h2>

        <DialogContent>
          <a style={{ fontSize: "smaller" }}>
            Are you sure you want to delete{" "}
            <strong>{localStorage.getItem("useremail")}</strong> ?{" "}
          </a>
        </DialogContent>

        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold active:bg-blueGray-600 uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle2}
            size="sm"
          >
            Close
          </button>
          <button
            className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={Delete(state.delete_id)}
            size="sm"
          >
            Delete
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open3}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose3}
        aria-describedby="alert-dialog-slide-description"
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "810",
            color: "rgb(48, 68, 115)",
            fontFamily: "sans-serif",
            lineHeight: "4.5rem",
          }}
        >
          User is Inactive
        </h2>
        {userlist.map((userlist) => {
          return (
            <React.Fragment>
              {userlist.email === state.email ? (
                <React.Fragment>
                  <DialogContent>
                    <a style={{ fontSize: "smaller" }}>
                      User already exist, It is in Inactive state. if you want
                      to Activate the account,{" "}
                      <strong>Please Click Activate</strong> ? {state.email}
                    </a>
                  </DialogContent>
                  <DialogActions>
                    <button
                      className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      onClick={toggle3}
                      size="sm"
                    >
                      Close
                    </button>
                    <button
                      className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      onClick={activate(userlist.id)}
                      size="sm"
                    >
                      Activate
                    </button>
                  </DialogActions>{" "}
                </React.Fragment>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        })}
      </Dialog>
      <UserHeader content="This is your User Management page. Here you can see the all users, create and manage your users and grant the permissions based on group" />
      {/* <Container className="mt--9" fluid> */}

      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={focusAfterClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <form>
            <div className="head" style={{ height: "80px" }}>
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  color: "rgb(48, 68, 115)",
                  fontFamily: "sans-serif",
                  lineHeight: "4.5rem",
                }}
              >
                CREATE USER
              </h2>
            </div>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="email" className="ml-4">
                <strong>Email</strong>
              </FormLabel>

              <TextField
                fullWidth
                htmlFor="email"
                placeholder="Email"
                type="email"
                autoComplete="new-email"
                name="email"
                id="email"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
                size="small"
                className="form-control"
                value={state.email}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="username" className="ml-4">
                <strong>Username</strong>
              </FormLabel>

              <TextField
                fullWidth
                htmlFor="username"
                placeholder="Name"
                id="username"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SchoolIcon />
                    </InputAdornment>
                  ),
                }}
                size="small"
                className="form-control"
                value={state.username}
                onChange={handleChange}
                type="text"
                name="username"
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="password" className="ml-4">
                <strong>Password</strong>
              </FormLabel>
              <OutlinedInput
                fullWidth
                htmlFor="password"
                placeholder="password"
                type={state.showPassword ? "text" : "password"}
                autoComplete="new-password"
                name="password"
                id="password"
                className="form-control"
                value={state.password}
                onChange={handleChange}
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <LockOpenIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="password2" className="ml-4">
                <strong>Confirm Password</strong>
              </FormLabel>

              <OutlinedInput
                fullWidth
                placeholder="Confirm password"
                type={state.showPassword2 ? "text" : "password"}
                autoComplete="new-password"
                name="password2"
                id="password2"
                className="form-control"
                value={state.password2}
                onChange={handleChange}
                size="small"
                startAdornment={
                  <InputAdornment position="start">
                    <LockOpenIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword2}
                      onMouseDown={handleMouseDownPassword2}
                    >
                      {state.showPassword2 ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <FormLabel htmlFor="groups" className="ml-4">
                <strong>Group</strong>
              </FormLabel>

              <TextField
                fullWidth
                htmlFor="groups"
                placeholder="Group"
                type="select"
                autoComplete="groups"
                name="groups"
                id="groups"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <GroupIcon />
                    </InputAdornment>
                  ),
                }}
                size="small"
                className="form-control"
                value={state.groups}
                onChange={handleChange}
                select
                SelectProps={{ native: true }}
              >
                {" "}
                <option>Select Group</option>
                <option value="1">Admin</option>
                <option value="2">Read-Only</option>
                <option value="3">OPS</option>
                <option value="4">Remedy</option>
              </TextField>
            </FormGroup>
          </form>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={refreshPage}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="submit"
            onClick={handleSubmitClick}
          >
            Create
          </button>
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          action={
            <React.Fragment>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                size="sm"
                onClick={toggle}
                style={{ float: "right" }}
              >
                + User
              </button>
            </React.Fragment>
          }
          title="USERS LIST"
        />
        <Paper sx={{ width: "100%" }}>
          <TableContainer sx={{ maxHeight: 1050 }}>
            <Table>
              <TableHead className="bg-lightBlue-200">
                <TableRow>
                  <TableCell>UserName</TableCell>
                  <TableCell>Email-ID</TableCell>
                  <TableCell>Status</TableCell>
                  {window.localStorage.getItem("audit_run_access") ===
                  "You do not have permission to perform this action." ? (
                    ""
                  ) : (
                    <React.Fragment>
                      <TableCell>Edit</TableCell>
                      <TableCell>Delete</TableCell>
                    </React.Fragment>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {unique
                  .slice(page * limit, page * limit + limit)
                  .filter((val) => {
                    if (searchitems == "") {
                      return val;
                    } else if (
                      val[cloumnName]
                        .toLowerCase()
                        .includes(searchitems.toLowerCase())
                    ) {
                      return val;
                    }
                  })
                  .map((userlist) => {
                    if (userlist.is_active === "True") {
                      return (
                        <TableRow>
                          <TableCell>{userlist.username} </TableCell>
                          <TableCell>{userlist.email} </TableCell>
                          <TableCell>Active</TableCell>
                          {localStorage.getItem("user") ===
                          userlist.username ? (
                            <React.Fragment>
                              <TableCell>
                                <ProfileEdit
                                  ProfileID={userlist.id}
                                  Disabled="true"
                                />
                              </TableCell>
                              <TableCell>
                                <button
                                  className="bg-red-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                  size="sm"
                                  style={{ marginLeft: "26px" }}
                                  disabled="true"
                                >
                                  Delete
                                </button>
                              </TableCell>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <TableCell>
                                <ProfileEdit ProfileID={userlist.id} />
                              </TableCell>
                              <TableCell>
                                <button
                                  className="bg-red-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                  onClick={() => {
                                    toggle2();
                                    localStorage.setItem(
                                      "useremail",
                                      userlist.email
                                    );
                                    del(userlist.id);
                                  }}
                                  size="sm"
                                  style={{ marginLeft: "26px" }}
                                >
                                  Delete
                                </button>
                              </TableCell>
                            </React.Fragment>
                          )}
                        </TableRow>
                      );
                    }
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          component="div"
          count={userlist.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Card>
    </>
  );
};

export default Profile;